export class MusicGenre {
	public id: number
	public name: string
	public key: string

	constructor({ id, name, key }: { id: number; name: string; key: string }) {
		this.id = id
		this.name = name
		this.key = key
	}

	// Factory method for creating from partial data
	static create(partial: Partial<MusicGenre>): MusicGenre {
		const defaults = {
			id: 0,
			name: '',
			key: '',
		}

		return new MusicGenre({ ...defaults, ...partial })
	}
}
